import React, { useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap'

import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

const UserDetailsSelect = (props) => {


  console.log('props.useserdetails=', props.userData);

  let history = useHistory();
  const [data, setdata] = useState(
    {

      corporate_name: '',
    })
  const [scheme, setscheme] = useState([]);

  let [err, seterr] = useState({})


  const fetscallScheme = () => {
    axios.get('/get_schemes_stamp_paper').then((res) => {
      setscheme(res.data.data)
    })
  }

  const getdata = (ev) => {
    let date_from = ''
    if (ev) {
      date_from = new Date(ev).toDateString()
    }
    return date_from
  }

  const getScheme = () => {
    axios.get('/get_schemes_stamp_paper')
      .then(res => {
        console.log(res, 'respo')
        if (res.data) {
          setscheme(res.data.data)
        }
      })
  }
  useEffect(() => {
    getScheme()
  }, [])


  return (
    <>
      <div className='mainuserdet' style={{
        backgroundColor: "transparent", height: "35vh", display: "flex", justifyContent: "center"
      }}>
        <div className="light" style={{ alignSelf: "center", width: "100%", height: "80%", fontSize: "28px", background: "#FFFFFF", paddingLeft:"50px" }}>

          <Form >
              {/*
            <Form.Group className="mb-10">
              <Form.Label>Select Scheme</Form.Label>
              <select onChange={(ev) => {
                setdata({ ...data, corporate_name: ev.target.value })
                seterr({ ...err, corporate_name: '' })
              }} className='form-select' name="corporate_name" id="corporate_name">
                <option key='-1' value="">Select</option>
                {scheme.map((scemedata, i) => {
                  return (
                    <option key={i} value={scemedata.scheme_name}>{scemedata.scheme_name}</option>
                  )
                })}
              </select>
            </Form.Group>
              */}
            <Form.Group className="mb-10">
              <Form.Label>Choose Role</Form.Label><br />
              <select aria-label="Default select example" onChange={ev=>{
                if(ev.target.value){
                  axios.get('/change_role?role='+ev.target.value).then(res=>{
                    console.log('changed_role')
                    history.replace('/')
                    window.location.reload()
                  })
                }
              }} >
                <option key={-1} label='Choose' value={''}/>
               {props.userData?.roles?.length !== 0 &&
                props.userData?.roles?.map((dat, i)=>{
                  console.log('dmkdsmsd', dat)
                  return(
                    <option key={{i}} label={dat} value={dat} />
                    
                  )
                })
                }

              </select>

    </Form.Group>
            
       </Form>
       {/* <a href='/' type='button'className='button btn-primary btn-lg' style={{textDecoration:"none", marginLeft:"80%", marginTop:"30%",fontSize:"16px"}}>Logout</a> */}
        </div>
      </div>


    </>
      )
}
export default UserDetailsSelect;